export type VariationIdentifier = {
    readonly groupId: number;
    readonly optionId: number;
}

export default abstract class AbstractProductVariationsView
{
    protected htmlOptionClass = 'js-variation-option';

    public abstract set(groupId: string, optionId: string, optionValue: string, parent: Element): void;

    public abstract createSelector(groupId: string, optionId: string): string;

    public abstract changeItemsActivity(parent: Element, enabledValues: Number[]);

    public getVariationIdentifier(nodeIdentifier: string): VariationIdentifier
    {
        let parts = nodeIdentifier.split('_');

        return {optionId: Number(parts.pop()), groupId: Number(parts.pop())};
    }

    protected createOptionName(groupId: string, optionId: string): string
    {
        return `variation_${groupId}_${optionId}`;
    }
}
